module.exports = __webpack_public_path__ + "static/media/7.75072c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobileOmBoarding/7.png
// module id = 936
// module chunks = 21